import PartState from "./PartState";
import TypeState from "./TypeState";

export default class QuantityState {
	constructor(
		public readonly partState: PartState[],
		public readonly typeState: TypeState[],
	) {}
}